module.exports = __webpack_public_path__ + "static/media/maha_logo_horizontal.84bcc899.jpg";